import { FunctionComponent, memo } from "react";
import { IProps } from "./download-interaction-pdf.types";
import { EllipsisMenuItem } from "@edgetier/client-components";
import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { jsPDF } from "jspdf";
import {
    PDF_DEFAULT_HEIGHT,
    PDF_DEFAULT_WIDTH,
    PDF_OFFSET_VALUE,
    PDF_SCALE,
} from "./download-interaction-pdf.constants";
import toast from "react-hot-toast";
import "./download-interaction-pdf.scss";
/**
 * Menu item to download a interactions as PDF
 * @param props.interactionId
 */
const DownloadInteractionPdf: FunctionComponent<IProps> = ({ interactionId }) => {
    // Convert a DOM element into a PDF and save the file
    const downloadToPdf = () => {
        const elementClassName = "interaction-pdf-content";
        const interactionPdfElement = document.getElementsByClassName(elementClassName)[0] as HTMLElement;

        if (typeof interactionPdfElement !== "undefined") {
            const toastSavePDF = toast.loading("Preparing the PDF file ...");
            const messagesHeight = interactionPdfElement.querySelector(".interaction-messages")?.clientHeight;

            const pdfFormatHeight =
                typeof messagesHeight === "number" && messagesHeight > PDF_DEFAULT_HEIGHT
                    ? messagesHeight * PDF_SCALE + PDF_OFFSET_VALUE
                    : PDF_DEFAULT_HEIGHT;

            const pdfDocument = new jsPDF({
                orientation: "p",
                unit: "px",
                format: [PDF_DEFAULT_WIDTH, pdfFormatHeight],
                putOnlyUsedFonts: true,
            });

            // Clone the element and put it behind of the model content
            const documentPdfElement = interactionPdfElement.cloneNode(true) as HTMLElement;
            interactionPdfElement.before(documentPdfElement);

            // Apply a class name for fixing some styles for printing
            documentPdfElement.classList.add("document-pdf-element");

            // Prepare the element to be printed
            pdfDocument.html(documentPdfElement, {
                callback: (doc) => {
                    // Save to PDF
                    try {
                        doc.save(`watchtower-interaction-${interactionId}.pdf`);
                        // Remove the clone element
                        documentPdfElement.remove();
                        toast.success("PDF file created", { id: toastSavePDF });
                    } catch (error) {
                        toast.success("An error occurred", { id: toastSavePDF });
                    }
                },
                html2canvas: {
                    logging: false,
                    scale: PDF_SCALE,
                    svgRendering: true,
                },
                margin: 0,
                autoPaging: "text",
                x: 0,
                y: 0,
            });
        }
    };
    return (
        <EllipsisMenuItem icon={faFilePdf} onClick={downloadToPdf}>
            Export to PDF
        </EllipsisMenuItem>
    );
};

export default memo(DownloadInteractionPdf);
